"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmploymentStore = void 0;
class EmploymentStore {
    data = {};
    constructor() {
    }
    add(e) {
        this.data[e.getId()] = e;
    }
    byId(id) {
        return this.data[id];
    }
    query(options) {
        return Object.values(this.data).filter(e => {
            if (options?.userId && e.getUserId() != options.userId) {
                return false;
            }
            ;
            if (options?.branchId && e.getBranchId() != options.branchId) {
                return false;
            }
            if (options?.employeeId && e.employeeId != options.employeeId) {
                return false;
            }
            return true;
        });
    }
    delete(id) {
        if (!this.data[id]) {
            return;
        }
        delete this.data[id];
    }
}
exports.EmploymentStore = EmploymentStore;
